export const feedsTranslations = {
  en: {
    allPosts: "All Posts",
    myPosts: "My Posts",
    noPostsYet: "No posts yet",
    noPostsMessageAll: "No posts available. Be the first to share something!",
    noPostsMessageMy: "You haven't created any posts yet. Start sharing your insights!",
    loadingPosts: "Loading posts...",
    editPost: "Edit Post",
    deletePost: "Delete Post",
    postTitlePlaceholder: "Post Title",
    postContentPlaceholder: "Post Content",
    addCommentPlaceholder: "Add a comment...",
    like: "Like",
    unlike: "Unlike",
    comment: "Comment",
    comments: "Comments",
    noComments: "No comments yet. Be the first to comment!",
    peopleWhoLiked: "People who liked this",
    noLikesYet: "No likes yet",
    deleteConfirmationPost: "Are you sure you want to delete this post?",
    confirmDelete: "Confirm Delete",
    deleteConfirmationComment: "Are you sure you want to delete this comment?",
    yes: "Yes",
    no: "No",
    cancel: "Cancel",
    delete: "Delete",
    save: "Save",
    addMedia: "Add Media",
    titleRequired: "Title is required",
    titleLengthError: "Title must be between 2 and 100 characters",
    descriptionRequired: "Description is required",
    descriptionLengthError: "Description cannot exceed 2000 characters",
    maxFilesError: "Cannot upload more than 10 files",
    failedUpdatePost: "Failed to update post",
    media: "Media",
    postUpdatedSuccess: "Post updated successfully",
    video: "Video {0}",
    videoAria: "Video {0} for post {1}",
    mediaAlt: "Media {0}",
    profileAlt: "{0}'s profile",
    verifiedUser: "Verified user",
    postOptions: "Post options",
    removeMedia: "Remove media",
    newVideo: "New video {0}",
    showLikes: "Show likes",
    showComments: "Show comments",
    submitComment: "Submit comment",
    yourProfile: "Your profile",
    commentProfileAlt: "{0}'s profile",
    deleteComment: "Delete comment",
    postDeletedSuccess: "Post deleted successfully",
    commentDeletedSuccess: "Comment Deleted successfully",
    search_by_title: "Search by title",
    select_sport: "Select sport",
    select_weight_class: "Select weight class",
    select_manager_type: "Select manager type",
    select_profile_type: "Select profile type",
    no_sports_available: "No sports available",
    no_weight_classes_available: "No weight classes available",
    no_manager_types_available: "No manager types available",
    no_profile_types_available: "No profile types available",
    reset_filters: "Reset filters",
    reportPost: "Report Post",
    reportPostDescription: "Please provide a reason for reporting this post.",
    reportReasonPlaceholder: "Describe why you're reporting this post...",
    submitReport: "Submit Report",
    close: "Close",
    noDataForSelectedFilters: "No data for selected filters",
    topProfiles: "Top Profiles",
      noDataSuggestion: "Try broadening your filters to see more profiles.",
  },

  de: {
    allPosts: "Alle Beiträge",
    myPosts: "Meine Beiträge",
    noPostsYet: "Noch keine Beiträge",
    noPostsMessageAll: "Keine Beiträge verfügbar. Sei der Erste, der etwas teilt!",
    noPostsMessageMy: "Du hast noch keine Beiträge erstellt. Teile deine Gedanken!",
    loadingPosts: "Beiträge werden geladen...",
    editPost: "Beitrag bearbeiten",
    deletePost: "Beitrag löschen",
    postTitlePlaceholder: "Titel des Beitrags",
    postContentPlaceholder: "Inhalt des Beitrags",
    addCommentPlaceholder: "Kommentar hinzufügen...",
    like: "Gefällt mir",
    unlike: "Gefällt mir nicht mehr",
    comment: "Kommentar",
    comments: "Kommentare",
    noComments: "Noch keine Kommentare. Sei der Erste, der kommentiert!",
    peopleWhoLiked: "Personen, denen dies gefallen hat",
    noLikesYet: "Noch keine Likes",
    deleteConfirmationPost: "Möchtest du diesen Beitrag wirklich löschen?",
    confirmDelete: "Löschen bestätigen",
    deleteConfirmationComment: "Möchtest du diesen Kommentar wirklich löschen?",
    yes: "Ja",
    no: "Nein",
    cancel: "Abbrechen",
    delete: "Löschen",
    save: "Speichern",
    addMedia: "Medien hinzufügen",
    titleRequired: "Titel ist erforderlich",
    titleLengthError: "Titel muss zwischen 2 und 100 Zeichen lang sein",
    descriptionRequired: "Beschreibung ist erforderlich",
    descriptionLengthError: "Beschreibung darf 2000 Zeichen nicht überschreiten",
    maxFilesError: "Es können nicht mehr als 10 Dateien hochgeladen werden",
    failedUpdatePost: "Fehler beim Aktualisieren des Beitrags",
    media: "Medien",
    postUpdatedSuccess: "Beitrag erfolgreich aktualisiert",
    video: "Video {0}",
    videoAria: "Video {0} für Beitrag {1}",
    mediaAlt: "Medien {0}",
    profileAlt: "Profil von {0}",
    verifiedUser: "Verifizierter Benutzer",
    postOptions: "Beitragsoptionen",
    removeMedia: "Medien entfernen",
    newVideo: "Neues Video {0}",
    showLikes: "Likes anzeigen",
    showComments: "Kommentare anzeigen",
    submitComment: "Kommentar absenden",
    yourProfile: "Dein Profil",
    commentProfileAlt: "Profil von {0}",
    deleteComment: "Kommentar löschen",
    postDeletedSuccess: "Beitrag erfolgreich gelöscht",
    commentDeletedSuccess: "Kommentar erfolgreich gelöscht",
    search_by_title: "Nach Titel suchen",
    select_sport: "Sportart auswählen",
    select_weight_class: "Gewichtsklasse auswählen",
    select_manager_type: "Manager-Typ auswählen",
    select_profile_type: "Profiltyp auswählen",
    no_sports_available: "Keine Sportarten verfügbar",
    no_weight_classes_available: "Keine Gewichtsklassen verfügbar",
    no_manager_types_available: "Keine Manager-Typen verfügbar",
    no_profile_types_available: "Keine Profiltypen verfügbar",
    reset_filters: "Filter zurücksetzen",
    reportPost: "Beitrag melden",
    reportPostDescription: "Bitte geben Sie einen Grund an, warum Sie diesen Beitrag melden.",
    reportReasonPlaceholder: "Beschreiben Sie, warum Sie diesen Beitrag melden...",
    submitReport: "Meldung senden",
    close: "Schließen",
     noDataForSelectedFilters: "Keine Daten für ausgewählte Filter",
     topProfiles: "Top-Profile",
     noDataSuggestion: "Versuchen Sie, Ihre Filter zu erweitern, um mehr Profile zu sehen.",
  },

  hr: {
    allPosts: "Svi postovi",
    myPosts: "Moji postovi",
    noPostsYet: "Još nema postova",
    noPostsMessageAll: "Nema dostupnih postova. Budi prvi koji će nešto podijeliti!",
    noPostsMessageMy: "Još niste stvorili nijedan post. Počnite dijeliti svoje uvide!",
    loadingPosts: "Učitavanje postova...",
    editPost: "Uredi post",
    deletePost: "Izbriši post",
    postTitlePlaceholder: "Naslov posta",
    postContentPlaceholder: "Sadržaj posta",
    addCommentPlaceholder: "Dodaj komentar...",
    like: "Sviđa mi se",
    unlike: "Ne sviđa mi se",
    comment: "Komentar",
    comments: "Komentari",
    noComments: "Još nema komentara. Budi prvi koji će komentirati!",
    peopleWhoLiked: "Osobe kojima se ovo svidjelo",
    noLikesYet: "Još nema lajkova",
    deleteConfirmationPost: "Jeste li sigurni da želite izbrisati ovaj post?",
    confirmDelete: "Potvrdi brisanje",
    deleteConfirmationComment: "Jeste li sigurni da želite izbrisati ovaj komentar?",
    yes: "Da",
    no: "Ne",
    cancel: "Otkaži",
    delete: "Izbriši",
    save: "Spremi",
    addMedia: "Dodaj medije",
    titleRequired: "Naslov je obavezan",
    titleLengthError: "Naslov mora imati između 2 i 100 znakova",
    descriptionRequired: "Opis je obavezan",
    descriptionLengthError: "Opis ne smije prelaziti 2000 znakova",
    maxFilesError: "Ne može se učitati više od 10 datoteka",
    failedUpdatePost: "Neuspjelo ažuriranje posta",
    media: "Mediji",
    postUpdatedSuccess: "Post uspješno ažuriran",
    video: "Video {0}",
    videoAria: "Video {0} za post {1}",
    mediaAlt: "Mediji {0}",
    profileAlt: "Profil od {0}",
    verifiedUser: "Verificirani korisnik",
    postOptions: "Opcije posta",
    removeMedia: "Ukloni medije",
    newVideo: "Novi video {0}",
    showLikes: "Prikaži lajkove",
    showComments: "Prikaži komentare",
    submitComment: "Pošalji komentar",
    yourProfile: "Vaš profil",
    commentProfileAlt: "Profil od {0}",
    deleteComment: "Izbriši komentar",
    postDeletedSuccess: "Objava je uspješno izbrisana",
    commentDeletedSuccess: "Komentar je uspješno izbrisan",
    search_by_title: "Pretraži po naslovu",
    select_sport: "Odaberi sport",
    select_weight_class: "Odaberi težinsku kategoriju",
    select_manager_type: "Odaberi vrstu menadžera",
    select_profile_type: "Odaberi vrstu profila",
    no_sports_available: "Nema dostupnih sportova",
    no_weight_classes_available: "Nema dostupnih težinskih kategorija",
    no_manager_types_available: "Nema dostupnih vrsta menadžera",
    no_profile_types_available: "Nema dostupnih vrsta profila",
    reset_filters: "Poništi filtre",
    reportPost: "Prijavi post",
    reportPostDescription: "Molimo navedite razlog za prijavu ovog posta.",
    reportReasonPlaceholder: "Opišite zašto prijavljujete ovaj post...",
    submitReport: "Pošalji prijavu",
    close: "Zatvori",
    noDataForSelectedFilters: "Nema podataka za odabrane filtere",
    topProfiles: "Najbolji profili",
    noDataSuggestion: "Pokušajte proširiti filtre da biste vidjeli više profila.",
  },
};
